import type { ReceiptTemplate } from '../schema';

export const pandaExpressTemplate: ReceiptTemplate = {
  id: 'panda-express',
  name: 'Panda Express Receipt',
  brand: 'PANDA EXPRESS',
  description: 'Panda Express Chinese food receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'panda-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'PANDA EXPRESS',
        businessNameFontSize: 16,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'panda-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 12:45 PM\nGUEST #847',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'panda-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'PLATE (2 ENTREE)', quantity: '1', price: '11.30', sku: '' },
          { id: '2', name: '  ORANGE CHICKEN', quantity: '1', price: '0.00', sku: '' },
          { id: '3', name: '  KUNG PAO CHICKEN', quantity: '1', price: '0.00', sku: '' },
          { id: '4', name: '  FRIED RICE', quantity: '1', price: '0.00', sku: '' },
          { id: '5', name: 'CREAM CHEESE RANGOON', quantity: '1', price: '2.50', sku: '' },
          { id: '6', name: 'FOUNTAIN DRINK MED', quantity: '1', price: '2.40', sku: '' },
        ],
        showQuantity: false,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'panda-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '16.20', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.34', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '17.54', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'panda-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'panda-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU!\nVISIT PANDAEXPRESS.COM',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

